module.exports = __webpack_public_path__ + "img/1553620142.045f83e1.jpg";